import { capitalize } from '../../../common/utils/string.js';

import { ContentCard, Custom, MediaCard, MediaLayer, PostCard } from '../../../common/components/displayItems/items';

/**
 * CK - This was taken from Items.jsx and put in a more common location (here).
 *
 * Utility method to calculate the item React component class to use based on the template options for the module.
 *
 * @param  {Object} templateOpts Template options for the module.
 * @return {ReactElement} The item React component class.
 */
function getItemComponent(templateOpts, isOverlay) {
  const itemClassName = isOverlay ? templateOpts.details : templateOpts.itemTemplate;
  switch (itemClassName.toLowerCase()) {
    case 'medialayer':
      return MediaLayer;
    case 'mediacard':
      return MediaCard;
    case 'postcardcarousel':
      return PostCard;
    case 'custom':
      return Custom;
    case 'contentcard':
    case 'content':
      return ContentCard;
    case 'media':
      return MediaCard;
    default:
      return ContentCard;
  }
}

/**
 *
 * CK - This was taken from Items.jsx and put in a more common location (here).
 * Utility method to retrieve a custom item object for a given index. Will work out if the given index
 * required a custom item to be rendered based on logic like repeat every N items.
 *
 * @param  {Integer} index The numeric index of the item.
 * @param  {Array} customItems The array of cusotm item objets.
 * @return {Object} The matching custom item object.
 */
function getCustomItemForIndex(index, customItems) {
  let _customItem;

  // Determine if this index requires a custom item to be output.
  for (const itemIndex in customItems) {
    const _item = customItems[itemIndex];

    // Check if the indexes are equal.
    if (itemIndex == index) {
      _customItem = customItems[itemIndex];

      // Check if this item has a repeat setting.
    } else if (_item.repeat) {
      const remainder = (index - itemIndex) % _item.repeat;
      if (remainder === 0) {
        _customItem = customItems[itemIndex];
      }
    }
  }

  return _customItem;
}

export default {
  getItemComponent,
  getCustomItemForIndex,
};
